export const STEP = {
  SURVEY: 'survey',
  TEXT: 'text',
  THANK_YOU: 'thank-you',
};

export const ANSWER = {
  DISSATISFIED: 'Dissatisfied',
  NEUTRAL: 'Neutral',
  SATISFIED: 'Satisfied',
};

export const SURVEY_BUTTONS = [
  { icon: 'icon-sentiment_dissatisfied', label: ANSWER.DISSATISFIED },
  { icon: 'icon-sentiment_neutral', label: ANSWER.NEUTRAL },
  { icon: 'icon-sentiment_satisfied', label: ANSWER.SATISFIED },
];
